import { render, staticRenderFns } from "./ReviewNotesList.vue?vue&type=template&id=4fc62478&scoped=true"
import script from "./ReviewNotesList.vue?vue&type=script&lang=js"
export * from "./ReviewNotesList.vue?vue&type=script&lang=js"
import style0 from "./ReviewNotesList.vue?vue&type=style&index=0&id=4fc62478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc62478",
  null
  
)

export default component.exports